import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=1b8c3136&scoped=true"
import script from "./OfferPage.vue?vue&type=script&lang=ts"
export * from "./OfferPage.vue?vue&type=script&lang=ts"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=1b8c3136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c3136",
  null
  
)

export default component.exports